<kendo-dialog
	title="Reset Password"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	[minWidth]="250"
	[width]="350">
	<div>
		<p>Your password will be sent to the email address registered on your account.</p>
	</div>
	<kendo-dialog-actions>
		<button
			kendoButton
			kpaKendoButton="secondary"
			(click)="close('dialog')">
			Cancel</button
		>&nbsp;
		<button
			kendoButton
			kpaKendoButton="primary"
			(click)="resendCredentials(employeeId)">
			Okay
		</button>
	</kendo-dialog-actions>
</kendo-dialog>
